export const DEFAULT_SESSION_START_EVENT = 'session_start';
